import { render } from "./ClassRenderer.vue?vue&type=template&id=8e315db0&scoped=true"
import script from "./ClassRenderer.vue?vue&type=script&lang=js"
export * from "./ClassRenderer.vue?vue&type=script&lang=js"

import "./ClassRenderer.vue?vue&type=style&index=0&id=8e315db0&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e315db0"]])

export default __exports__